import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const getDealershipPerCuit = async (cuit, context = {}) => {
  if (cuit === null) {
    return;
  }

  try {
    const getDealershipFn = httpsCallable(functions, 'getDealershipPerCuitV2');
    const result = await getDealershipFn({
      cuit,
      groupId: context.activeGroupId || context.groupId,
      requestedApp: 'group_web',
    });
    return result.data;
  } catch (error) {
    console.error('Error obteniendo concesionario por CUIT:', error);
    notifyPermissionDenied(error);
    return { success: 'no', message: error.message };
  }
};
